import { IPaths } from 'Shared/Core/ApiPath/IPaths';

export const OidcPaths: IPaths = {
  Oidc: {
    SignIn: '/SignIn',
    SignOut: '/SignOut',
    SignInCallback: '/SignInCallback',
    SignOutCallBack: '/SignOutCallback',
    SilentCallback: '/SilentCallback',
    AutoLogin: '/SignInCallback/autologin',
  },
};
